import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Api from 'app/helpers/api';
import App from 'app/helpers/app';
import Me from 'app/helpers/me';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { take } from 'rxjs/operators';
import { CityService } from 'app/shared/services/cidades.service';
import * as cep from 'cep-promise';

interface Filters {
  municipio?: string;
  situacao?: number;
  periodoCadastroInicio?: string;
  periodoCadastroFim?: string;
  isCliente?: boolean;
}

@Component({
  selector: 'app-home-admin',
  templateUrl: './home-admin.component.html',
  styleUrls: ['./home-admin.component.scss']
})
export class HomeAdminComponent implements OnInit {
  apiCall = this.api.new().silent();
  page = 1
  pageSize = 10
  
  // Variáveis para paginação das cidades
  cidadesPage = 1
  cidadesPageSize = 10
  cidadesTotal = 0
  cidadesData = []
  
  atualizacaoSenha = {
    novaSenha: null,
    confirmaNovaSenha: null,
  }
  cities = []
  userToUpdate = null
  tipoUsuario = null
  filterCidade
  filterCidadecomUsuarios

  usuarioValidade = {
    id : null,
    validade : null,
  }
  usuarios = []
  usuariosOriginal = []
  cidadesComUsuarios = []

  cidadesComUsuariosOriginal = []

  cidadeUsuarios = {
    city: '',
    users: []
  };

  situacoesCadastrais = [
    { id: 1, label: 'Inativo' },
    { id: 2, label: 'Ativo' },
    { id: 3, label: 'Incompleto' }
  ]

  // Propriedades para funcionalidades existentes
  sortColumn: string = '';
  sortDirection: string = 'asc'; 
  cidadesFiltered = [];
  collapsedStates: {[key: string]: boolean} = {};

  // Propriedades para ordenação
  currentSortColumn: string = '';
  currentSortDirection: string = 'asc';

  filters: Filters = {
    municipio: null,
    situacao: null,
    periodoCadastroInicio: null,
    periodoCadastroFim: null,
    isCliente: null
  };

  // Variáveis para o formulário de cadastro de cliente
  cliente = {
    cep: null,
    estado: null,
    municipio: null,
    logradouro: null,
    numero: null,
    complemento: null,
    bairro: null,
    tipo_logradouro: null
  };

  estados = [];
  cidades = [];
  tiposLogradouro = [];

  // Referência ao Math para uso no template
  Math = Math;

  // Propriedades para Integração FlaxFlow
  anexo = {
    arquivos: [],
    opcao: "processarEAnexar"
  };
  statusEnvio: string = '';

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private http: HttpClient,
    private api: Api,
    private cityService: CityService,
  ) {
  }

  async ngOnInit() {
   const self = this
    self.usuarioValidade = {
      id : null,
      validade : null,
    }
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });

    // Carrega estados e tipos de logradouro para o formulário de cliente
    const estados = await self.apiCall.get('enderecos/estados').pipe(take(1)).toPromise()
    self.estados = JSON.parse(JSON.stringify(estados));

    const tiposLogradouro = await self.apiCall.get('enderecos/tiposlogradouro').pipe(take(1)).toPromise()
    self.tiposLogradouro = JSON.parse(JSON.stringify(tiposLogradouro));
    
    // Carrega cidades com paginação
    await this.loadCidades();

    const data = await self.apiCall.get('users/lista/servidor').pipe(take(1)).toPromise()

    self.usuarios = JSON.parse(JSON.stringify(data))

    const cidades = self.getUniqueCityNames(self.usuarios)   


// Adiciona usuários às suas respectivas cidades
self.usuarios.forEach(usuario => {
  if (this.cidadesComUsuarios[usuario.nomeCidade]) {
      this.cidadesComUsuarios[usuario.nomeCidade].push(usuario);
  }
});

const resultado = cidades.map(cidade => {
  const usuariosDaCidade = self.usuarios.filter(usuario => usuario.nomeCidade === cidade);

  // Verifica se há usuários na cidade para pegar o código da cidade
  const cidadeId = usuariosDaCidade.length > 0 ? usuariosDaCidade[0].cidade : null;

  return {
      city: cidade,
      id: cidadeId,
      users: usuariosDaCidade
  };
});

// Filtra cidades que têm usuários
this.cidadesComUsuarios = resultado.filter(cidade => cidade.users.length > 0);

// Define os estados colapsados
this.cidadesComUsuarios.forEach((cidade, index) => {
  this.collapsedStates[cidade.city] = index !== 0;
});


console.log(this.cidadesComUsuarios)

// for(let u of self.usuarios){
    //   if(u.nomeCidade){
    //     const retorno = await self.http.get('https://lz3cfpx1ie.execute-api.us-east-1.amazonaws.com/dev/clientes/validade/'+u.nomeCidade).toPromise()
    //     u.backoffice = JSON.parse(JSON.stringify(retorno)).return
    //   }
    // }
    self.spinner.hide()

    self.usuariosOriginal = [...self.usuarios]

    self.cidadesComUsuariosOriginal = [...self.cidadesComUsuarios]

  //  const estadosCivis = await self.apiCall.get('servidor/estadocivil').pipe(take(1)).toPromise()

  }

  async loadCidades() {
    const params = this.buildSearchParams();
    
    try {
      const cities = await this.cityService.getCidades(params);
      
      if(cities && cities.data){
        this.cidadesData = cities.data;
        this.cidadesTotal = cities.total;
        console.log('Cidades carregadas:', cities);
      }
    } catch (error) {
      console.error('Erro ao carregar cidades:', error);
      await this.app.alert('Erro!', 'Erro ao carregar municípios. Tente novamente.', 'error');
    }
  }

  // Método para buscar dados com indicador de carregamento
  async loadCidadesWithCurrentFilters() {
    this.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    try {
      await this.loadCidades();
    } finally {
      this.spinner.hide();
    }
  }

  // Mudança de página
  async onCidadesPageChange(page: number) {
    this.cidadesPage = page;
    await this.loadCidadesWithCurrentFilters();
  }

  // Construir parâmetros de busca sanitizados
  buildSearchParams(): any {
    const offset = (this.cidadesPage - 1) * this.cidadesPageSize;
    let params: any = {
      offset: offset,
      limit: this.cidadesPageSize
    };

    // Sanitizar e adicionar filtros apenas se tiverem valores
    if (this.filters.municipio && this.filters.municipio.trim() !== '') {
      params.nome = this.filters.municipio.trim();
    }

    if (this.filters.situacao) {
      switch (this.filters.situacao) {
        case 1:
          params.status = 'inativo';
          break;
        case 2:
          params.status = 'ativo';
          break;
        case 3:
          params.status = 'incompleto';
          break;
      }
    }

    if (this.filters.isCliente === true) {
      params.com_cadastro = 'true';
    }

    // Filtros de data
    if (this.filters.periodoCadastroInicio && this.filters.periodoCadastroInicio.trim() !== '') {
      const dataInicio = this.convertDateFormat(this.filters.periodoCadastroInicio);
      if (dataInicio) {
        params.data_cadastro_inicio = dataInicio;
      }
    }

    if (this.filters.periodoCadastroFim && this.filters.periodoCadastroFim.trim() !== '') {
      const dataFim = this.convertDateFormat(this.filters.periodoCadastroFim);
      if (dataFim) {
        params.data_cadastro_fim = dataFim;
      }
    }

    // Ordenação
    if (this.currentSortColumn && this.currentSortColumn.trim() !== '') {
      params.order_by = this.currentSortColumn;
      params.order_direction = this.currentSortDirection.toUpperCase();
    }

    console.log('Parâmetros de busca:', params);
    return params;
  }

  // Converter formato de data de dd/mm/yyyy para yyyy-mm-dd
  convertDateFormat(dateString: string): string | null {
    if (!dateString) return null;
    
    // Converter de dd/mm/yyyy para yyyy-mm-dd
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0');
      const month = parts[1].padStart(2, '0');
      const year = parts[2];
      return `${year}-${month}-${day}`;
    }
    return null;
  }

  // Aplicar filtros
  applyFilters() {
    console.log('Aplicando filtros:', this.filters);
    this.cidadesPage = 1; // Reset para primeira página
    this.loadCidadesWithCurrentFilters();
  }

  // Limpar filtros
  clearFilters() {
    this.filters = {
      municipio: null,
      situacao: null,
      periodoCadastroInicio: null,
      periodoCadastroFim: null,
      isCliente: null
    };
    this.cidadesPage = 1;
    this.currentSortColumn = '';
    this.currentSortDirection = 'asc';
    this.loadCidadesWithCurrentFilters();
  }

  // Método para ordenação das colunas
  sortTable(column: string) {
    // Mapear colunas do frontend para backend ANTES da comparação
    const columnMap = {
      'nome': 'nome',
      'usuarios': 'quantidade_usuarios',
      'orgaos': 'quantidade_orgaos',
      'status': 'status'
    };

    const mappedColumn = columnMap[column] || column;

    // Verificar se é a mesma coluna usando o valor mapeado
    if (this.currentSortColumn === mappedColumn) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = mappedColumn;
      this.currentSortDirection = 'asc';
    }

    this.cidadesPage = 1; // Reset para primeira página
    console.log(`Ordenando por: ${this.currentSortColumn} ${this.currentSortDirection}`);
    this.loadCidadesWithCurrentFilters();
  }

  // Método para mostrar indicador de ordenação
  getSortIcon(column: string): string {
    const columnMap = {
      'nome': 'nome',
      'usuarios': 'quantidade_usuarios',
      'orgaos': 'quantidade_orgaos',
      'status': 'status'
    };

    if (this.currentSortColumn === columnMap[column]) {
      return this.currentSortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  // Método para verificar se a coluna está sendo ordenada
  isColumnSorted(column: string): boolean {
    const columnMap = {
      'nome': 'nome',
      'usuarios': 'quantidade_usuarios',
      'orgaos': 'quantidade_orgaos',
      'status': 'status'
    };
    return this.currentSortColumn === columnMap[column];
  }

  getStatusCidade(cidade: any): string {
    const temUsuarios = cidade.quantidade_usuarios > 0;
    const temOrgaos = cidade.quantidade_orgaos > 0;
    
    if (temUsuarios && temOrgaos) {
      return 'Ativo';
    } else if (temUsuarios || temOrgaos) {
      return 'Incompleto';
    } else {
      return 'Inativo';
    }
  }

  getStatusColor(cidade: any): string {
    const status = this.getStatusCidade(cidade);
    switch (status) {
      case 'Ativo':
        return '#28a745';
      case 'Incompleto':
        return '#ffc107';
      case 'Inativo':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  }

  onDropdownAction(action: string, cidade: any) {
    console.log(`Ação: ${action} para cidade: ${cidade.nome}`);
    // Implementar navegação ou ações específicas para cada opção
    switch (action) {
      case 'usuarios':
        // Navegar para usuários da cidade
        break;
      case 'importacoes':
        // Navegar para importações da cidade
        break;
      case 'servidores':
        // Navegar para servidores da cidade
        break;
      case 'relatorios':
        // Navegar para relatórios da cidade
        break;
      case 'configuracoes':
        // Navegar para configurações da cidade
        break;
      case 'acesso_remoto':
        // Navegar para acesso remoto da cidade
        break;
      case 'permissoes':
        // Navegar para permissões da cidade
        this.router.navigate(['/page/permissoes'], { queryParams: { nomeCidade: cidade.nome } });
        break;
    }
  }

   getUniqueCityNames(users): string[] {
    const cityNames = new Set<string>();

    console.log(users)

    for (const user of users) {
        cityNames.add(user.nomeCidade);
    }

    return Array.from(cityNames);
}

toggleCollapse(cityName: string): void {
  if (this.collapsedStates[cityName] === undefined) {
    this.collapsedStates[cityName] = true;
  } else {
    this.collapsedStates[cityName] = !this.collapsedStates[cityName];
  }
}


  openModal(content, usuario, tipo){
    this.userToUpdate = usuario
    this.tipoUsuario = tipo
    const modal = this.modalService.open(content, { centered: true })
  }
  liberaValidade(content, usuario){

    if(!usuario.backoffice){
      return
    }
    this.usuarioValidade = {
      id : usuario.backoffice.id,
      validade : usuario.backoffice.validadeAcessoCenso ? moment(usuario.backoffice.validadeAcessoCenso).format('DDMMYYYY') : null,
    }

    const modal = this.modalService.open(content, { centered: true })
  }
  filter(){
    this.usuarios = [...this.usuariosOriginal]
    if(this.filterCidade){
      this.usuarios = this.usuarios.filter(x=>x.nomeCidade && x.nomeCidade.toLowerCase().includes(this.filterCidade.toLowerCase()))
    }
    this.usuarios = [...this.usuarios]

  }

  filterCity(){
    this.cidadesComUsuarios = [...this.cidadesComUsuariosOriginal]
    if(this.filterCidadecomUsuarios){
      this.cidadesComUsuarios = this.cidadesComUsuarios.filter(x=>x.city && x.city.toLowerCase().includes(this.filterCidadecomUsuarios.toLowerCase()))
    }
    this.cidadesComUsuarios = [...this.cidadesComUsuarios]

  }
  async updateValidade(modal){
    if(!this.usuarioValidade || !this.usuarioValidade.id || !this.usuarioValidade.validade){
      return
    }
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    await this.http.put('https://lz3cfpx1ie.execute-api.us-east-1.amazonaws.com/dev/clientes/validade', {
      id : this.usuarioValidade.id,
      validadeAcessoCenso : moment(this.usuarioValidade.validade, 'DDMMYYYY').toDate()
    }).toPromise()
    this.spinner.hide()
    await this.app.alert('Tudo certo!', 'Senha atualizada com sucesso!', 'success')
    modal.close('Close click')
    await this.ngOnInit()

  }
  async updateSenha(modal){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    await this.apiCall.get(`users/edicao/senha?idUsuario=${this.userToUpdate.id}&senha=${this.atualizacaoSenha.novaSenha}&tipoUsuario=${this.tipoUsuario}`).pipe(take(1)).toPromise()
    this.spinner.hide()
    await this.app.alert('Tudo certo!', 'Senha atualizada com sucesso!', 'success')
    modal.close('Close click')
    await this.ngOnInit()

  }

  async alterarStatusUsuario(id, ativo){
    if (ativo) {
      ativo = 0;
    } else {
      ativo = 1;
    }
    await this.apiCall.get(`users/edicao/status?idUsuario=${id}&ativo=${ativo}&tipoUsuario=2`).pipe(take(1)).toPromise()
    await this.app.alert('Tudo certo!', 'Usuário atualizado com sucesso!', 'success')
    await this.ngOnInit()

  }
  beautifulDate(date){
    return moment(date).format('DD/MM/YYYY')
  }

  async consultaCep() {
    const self = this;
    if (!self.cliente.cep) {
      return;
    }
    
    self.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    cep(self.cliente.cep)
      .then(async (local) => {
        self.cliente.logradouro = local.street;
        self.cliente.bairro = local.neighborhood;
        self.cliente.estado = local.state;
        self.cliente.municipio = null;
        self.cliente.tipo_logradouro = null;

        await self.toggleEstadoCliente();

        const foundCity = self.cidades.find((c) =>
          c.nome.toLowerCase().includes(local.city.toLowerCase())
        );
        if (foundCity) self.cliente.municipio = foundCity.id;

        const foundTipoLogradouro = self.tiposLogradouro.find((t) =>
          t.descricao
            .toLowerCase()
            .includes(local.street.split(" ")[0].toLowerCase())
        );
        if (foundTipoLogradouro) self.cliente.tipo_logradouro = foundTipoLogradouro.id;

        self.spinner.hide();
      })
      .catch((erro) => {
        console.error("Erro ao buscar o CEP:", erro);
        self.spinner.hide();
      });
  }

  async toggleEstadoCliente() {
    if (!this.cliente.estado) {
      return;
    }
    this.cidades = [];
    const cidades = await this.apiCall
      .get("enderecos/estados/cidades?estado=" + this.cliente.estado)
      .pipe(take(1))
      .toPromise();
    this.cidades = JSON.parse(JSON.stringify(cidades));
  }

  openModalCadastroCliente(content) {
    this.resetFormularioCliente();
    const modal = this.modalService.open(content, { centered: true, size: 'lg' });
  }

  resetFormularioCliente() {
    this.cliente = {
      cep: null,
      estado: null,
      municipio: null,
      logradouro: null,
      numero: null,
      complemento: null,
      bairro: null,
      tipo_logradouro: null
    };
    this.cidades = [];
  }

  async cadastrarCliente(modal) {
    const self = this;
    
    if (!this.isFormularioClienteValido()) {
      await this.app.alert('Atenção!', 'Por favor, preencha todos os campos obrigatórios.', 'warning');
      return;
    }

    self.spinner.show(undefined, {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });

    try {
      const dadosCliente = {
        id_cidade: self.cliente.municipio,
        cep: self.cliente.cep,
        logradouro: self.cliente.logradouro,
        numero: self.cliente.numero,
        complemento: self.cliente.complemento,
        bairro: self.cliente.bairro,
        tipo_logradouro: self.cliente.tipo_logradouro,
        estado: self.cliente.estado
      };

      const request = await this.cityService.cadastrarCidadeCliente(dadosCliente);
      console.log(request)
      
      if(request && request.success==true){

      self.spinner.hide();
      await this.app.alert('Sucesso!', 'Cliente cadastrado com sucesso!', 'success');
      modal.close('Close click');
      await this.ngOnInit(); // Recarrega os dados

      }else{
        self.spinner.hide();
        await this.app.alert('Erro!', request.error.error, 'error');
      }
      
      
    } catch (error) {
      self.spinner.hide();
      await this.app.alert('Erro!', 'Erro ao cadastrar cliente. Tente novamente.', 'error');
      console.error('Erro ao cadastrar cliente:', error);
    }
  }

  isFormularioClienteValido(): boolean {
    return !!(
      this.cliente.cep &&
      this.cliente.estado &&
      this.cliente.municipio &&
      this.cliente.logradouro &&
      this.cliente.numero &&
      this.cliente.bairro
    );
  }

  goToDetails(id: number){
    console.log("clicked")
    this.router.navigate(['/page/municipio/detalhe'], { queryParams: { idCidade: id } });
  }

  // Métodos para Integração FlaxFlow
  openModalDocumento(content, cidade){
    this.cidadeUsuarios.city = cidade;
    this.anexo = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvio = '';
    const modal = this.modalService.open(content, { centered: true });
  }

  closeModal(modal) {
    this.anexo = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvio = '';
    modal.close('Close click');
  }

  async selecionaArquivo(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const arquivosSelecionados = Array.from(input.files);
    const arquivosValidos: File[] = [];

    for (const file of arquivosSelecionados) {
      arquivosValidos.push(file);
    }

    if (arquivosValidos.length > 0) {
      this.anexo.arquivos = arquivosValidos;
    } else {
      this.anexo.arquivos = [];
      input.value = ""; // limpa o input, já que nenhum arquivo é válido
    }
  }

  fileNameAndExt(str) {
    var file = str.split("/").pop();
    return [
      file.substr(0, file.lastIndexOf(".")),
      file.substr(file.lastIndexOf(".") + 1, file.length),
    ];
  }

  async postFile(extension, type) {
    const response = await this.apiCall
      .post(`servidor/arquivo/url`, { extension: extension, type: type })
      .pipe(take(1))
      .toPromise();
    if (response.result) {
      return response.result;
    } else {
      return null;
    }
  }

  mapAction(opcao){
    switch(opcao) {
      case "processar":
        return 1;
      case "anexar":
        return 2;
      default:
        return 0;
    }
  }

  async cadastrarAnexo(modal) {
    const self = this;

    if (!self.anexo.arquivos || self.anexo.arquivos.length === 0) {
      return;
    }

    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    const dadosUsuario = self.me.currentUserValue;
    const cidade = self.cidadeUsuarios.city;
    const nome = dadosUsuario?.user?.nome;

    try {
      for (let i = 0; i < self.anexo.arquivos.length; i++) {
        const file = self.anexo.arquivos[i];
        
        self.statusEnvio = `Enviando (${i + 1}/${self.anexo.arquivos.length}): ${file.name}`;

        // Verificar se o arquivo tem extensão
        if (file && self.fileNameAndExt(file.name)[1]) {
          try {
            const urlToPostFile = await self.postFile(
              self.fileNameAndExt(file.name)[1],
              file.type
            );

            if (!urlToPostFile) {
              console.error(`Falha ao obter URL para upload do arquivo: ${file.name}`);
              continue;
            }

            var optionsFile = {
              headers: { "Content-Type": file.type, "x-amz-acl": "public-read" },
            };

            const uploadFile = await self.api.http
              .put(urlToPostFile, file, optionsFile)
              .toPromise();

            const locationFile = urlToPostFile.toString().split("?", 1)[0];
            const idaction = this.mapAction(this.anexo.opcao);

            if (locationFile) {
              const result = await self.apiCall
                .post(`servidor/flaxflow/createFile?key=${locationFile}&idcidade=${this.cidadeUsuarios.city}&idaction=${idaction}&nameFile=${file.name}`)
                .pipe(take(1))
                .toPromise();
              
              console.log(`Arquivo ${file.name} enviado com sucesso:`, locationFile);

              // Enviar para FlaxFlow
              if (idaction === 2) {
                continue; // Pula o envio para FlaxFlow se a ação for apenas anexar
              }
              try {
                // Converter arquivo para base64 de forma compatível com browser
                const base64Content = await this.fileToBase64(file);
                const idfile = result.idfile;
                
                // Obter token da FlaxFlow
                const flaxflowToken = await self.apiCall
                  .get(`servidor/flaxflow/gettokenflaxflow`)
                  .pipe(take(1))
                  .toPromise();

                const uploadData = {
                  file: locationFile,
                  idfile: idfile,
                  token: flaxflowToken.token,
                  fileName: file.name,
                  fileSize: file.size
                };

                const resultSendFile = await self.apiCall
                  .post(`servidor/flaxflow/uploadfile`, uploadData)
                  .pipe(take(1))
                  .toPromise();

                var teste = resultSendFile.result;
                console.log(`Arquivo enviado para FlaxFlow: ${file.name}`, teste);

              } catch (flaxflowError) {
                console.error(`Erro ao enviar para FlaxFlow: ${file.name}`, flaxflowError);
              }
            }
          } catch (e) {
            console.error(`Erro ao enviar arquivo ${file.name}:`, e);
            await self.app.alert(
              `Erro`,
              `Falha ao enviar o arquivo "${file.name}".`,
              `error`
            );
          }
        }
      }

      await self.app.alert(`Sucesso`, `Todos os arquivos foram integrados com o FlaxFlow!`, `success`);
      modal.close("Close click");
      self.statusEnvio = '';
      await self.loadCidadesWithCurrentFilters();
    } catch (error) {
      console.error("Erro ao enviar arquivos", error);
      await self.app.alert(`Erro`, `Ocorreu um erro ao enviar os arquivos.`, `error`);
    } finally {
      await self.spinner.hide();
    }
  }

  private async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }
}
